export default __webpack_public_path__ + "static/media/matcha-green-tea.796f32cd.png";